export const CARD_WIDTH = 430;
export const SMALL_CARD_WIDTH = 230;
export const PADDING = 24;
export const ARROW_SIZE = 36;

export const ARROW_TOTAL_WIDTH = ARROW_SIZE + PADDING;
export const DIFF_BETWEEN_SMALL_BIG =
  CARD_WIDTH + PADDING - (SMALL_CARD_WIDTH + PADDING);
